import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  standalone: false
})

/**
 * Maintenance Component 
 */
export class MaintenanceComponent implements OnInit {

  BUID: string;
  constructor() { }

  ngOnInit(): void {

  }

}
